import React from 'react';
import './ReportItem.css';

import { FaLink, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Import PhotoView from react-photo-view
import { PhotoView } from 'react-photo-view';



const ReportItem = (props) => {

  // Destructuring props
  const { id, image, title, category, report, className } = props;

  return (
    <div className={`report-item ${className}`} key={id}>
      <div className="report-content">

        {/* Report Image */}
        <img src={image} alt={title} />

        {/* Report Content */}
        <div className='content'>

        <div className='btn-container'>

          {/* Plus icon for lightbox */}
          <PhotoView src={image}>
            <div className='view icon'><FaPlus /></div>
          </PhotoView>

          <Link
            to={{
              pathname: '/Reports/' + title,
            }}
            state={report}
            className='icon'
          >
            <FaLink />
          </Link>

          </div>

          <div className='text'>

            {/* Report Category */}
            <p>{category}</p>

            {/* Link to the individual Report Detail Page */}
            <Link
              to={{
                pathname: '/Reports/' + title,
              }}
              state={report}
            >
              <h3>{title}</h3> {/* Report Title */}
            </Link>

          </div>

        </div>

      </div>
    </div>
  );
};

export default ReportItem;